import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { PriceListUerRowData } from 'gql/graphql';
import { isNotEmpty } from 'utils';

import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo, useState } from 'react';

export const useDataAgreementPriceListModal = (expandedRowData: PriceListUerRowData | null) => {
    const [filterValues, setFilterValues] = useState<Record<string, string[]>>({});

    const changeFilterHandler = useCallback<(params: { fieldName: string; checkedValues: string[] }) => void>(
        ({ fieldName, checkedValues }) => {
            setFilterValues((prevValue) => ({
                ...prevValue,
                [fieldName]: checkedValues,
            }));
        },
        [],
    );

    const sortedData = useMemo(
        () => expandedRowData?.workScopes?.slice().sort((a, b) => a.number - b.number),
        [expandedRowData?.workScopes],
    );

    const rowData = useMemo(() => {
        const hasActiveFilter = Object.values(filterValues).some(isNotEmpty);

        return hasActiveFilter
            ? sortedData?.filter(({ description }) => filterValues.description.includes(description))
            : sortedData;
    }, [filterValues, sortedData]);

    const columns = useMemo<ColDef<any>[]>(
        () => [
            {
                field: 'number',
                headerName: '№ пп',
                width: 128,
                spanHeaderHeight: true,
            },
            {
                field: 'description',
                headerName: 'Наименование',
                flex: 1,
                spanHeaderHeight: true,
                resizable: false,
                wrapText: true,
                autoHeight: true,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    changeFilterHandler,
                    filterItems: sortedData?.map(({ description }) => ({ label: description })),
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'label',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    isClientSideSearch: true,
                    childFieldAccessor: 'label',
                },
            },
        ],
        [changeFilterHandler, sortedData],
    );

    return useMemo(
        () => ({
            columns,
            rowData,
            title: `Расценка: ${expandedRowData?.code}` || '',
        }),
        [columns, expandedRowData?.code, rowData],
    );
};
